import { useContext } from "react";
import * as ReactRouter from "react-router-dom";

export default function useRouter<TParams = {}>() {
  return useContext(
    (ReactRouter as any).__RouterContext
  ) as ReactRouter.RouteComponentProps<TParams>;
}
